
var Model = require("../types/Model.js");
var extender = Model.makeExtender;
var asap = require("asap");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;
var BackgroundCheckModule = require("react-native-background-check");

// Wait two minutes to re-authenticate
var reauth_time = 2 * 60 * 1000;

/**
 * The model used for handling logins with an authentication token
 * @type {Model}
 */
module.exports = Model({
	name: "mobiletokenlogin",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_reauth_timer: null,

	authenticate_token: authenticate_token,
	clearReauth: clearReauth
});

function init() {

	return AsyncStorage.getItem("token").then(function (token) {
		this.push({
			has_handled: false,
			message: "", // A message to display on the UI
			token: "", // The token
			data: {}, // The authenticated data
			localization: {}, // The current localization file
			config: this.config,
			save: false
		});
		// eslint-disable-next-line no-extra-boolean-cast
		if (!!token) this.authenticate_token(token);
	}.bind(this));
}

function uninit() {
	this.clearReauth();
	if(BackgroundCheckModule)
		BackgroundCheckModule.clearWindow();
}

/**
 * Sets up the listeners for triggers, and changes in localization and filesystem
 */
function listeners() {
	return {
		"localization:updated": handle_localization_update,
		"toast:updated": extender("toast"),
		"save:updated": extender("save"),
		"machinetracker:updated": handle_machine_tracker_update
	};
}

function triggers() {
	return {
		"token": handle_trigger_token,
		"clear_message": handle_clear_message
	};
}

/**
 * This gets triggered by the UI or other modules in order to attempt to use a token.
 * The token gets authenticated and if it's valid the model is extended with it.
 * @param  {Object} data Should contain the `token` to use
 */
function handle_trigger_token(data) {
	this.emit("save:trigger:start");

	var token = data.token;
	this.authenticate_token(token);
}

function authenticate_token(token) {
	this.api.auth.auth(token)
		.then(handle_valid_token.bind(this, token))
		.catch(handle_invalid_token.bind(this, token));
}

/**
 * Whenever the machinetracker updates, fetch the token and display it
 * @param  {Object} data The state of MachineTracker. Contains `serial`, `apk`, and sometimes `token`
 */
function handle_machine_tracker_update(data) {
	if (this.data.has_handled) return;
	var token = data.token;
	if (token) this.authenticate_token(token);
	else this.emit("machinetracker:trigger:recover");
}

/**
 * Called when a successful token has been processed.
 * Updates the state with the new token
 * @param  {String} token The token
 */
function handle_valid_token(token, data) {
	this.emit("save:trigger:finish");
	if (!token) return;

	if(BackgroundCheckModule)
		BackgroundCheckModule.lightScreen();

	asap(function () {
		this.extend({
			token: token,
			data: data,
			has_handled: true
		});
		!this.has_handled && this.emit("usermetrics:trigger:track", "login with valid token"); // validate this GOUREVITCH TODO:
	}.bind(this));
}

/**
 * Called when logging in fails
 * @param  {Error} error The error that happened. S
 */
function handle_invalid_token(token, error) {
	this.emit("save:trigger:finish");

	var status = error.status;
	var status_map = {
		0: "login.loginerror1",
		401: "login.loginerror6",
		403: "login.loginerror6",
		404: "login.loginerror6",
		undefined: "login.loginerror1"
	};
	var message = status_map[status];
	if (message){
		this.extend({
			message: message
		});
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
	}

	// If there was a network error, or the token was found to be invalid.
	// Attempt to re-authenticate it after some time
	// Clear any previous attempt at re-authing
	if ((status === 0) || (status === 401)) {
		this.clearReauth();
		this._reauth_timer = setTimeout(authenticate_token.bind(this, token), reauth_time);
	}

	this.emit("usermetrics:trigger:track", "attempt to login but token is invalid");
}

/**
 * Handles changes in localization. Updates `localization` state.
 * @param  {Object} data The state of the Localization model. Contains `localization` map.
 */
function handle_localization_update(data) {
	this.extend({
		localization: data.localization
	});
}

function clearReauth() {
	if (this._reauth_timer)
		clearTimeout(this._reauth_timer);
	this._reauth_timer = null;
}

function handle_clear_message() {
	var message = "";
	this.extend({
		message: message
	});
	this.emit("usermetrics:trigger:track", "cancel token login");
}
